// This file maps state to stores, and also exposes a fetchData function to fetch all the
// data needed to render the smart component
import { FEATURE_FLAG_DATA } from '@src/constants/MogamboConstants';
import CommonStore from '@src/stores/CommonStore';
import ActionStore from '@src/ActionStore';
import BotStore from '../../store';

export const listenToStores = [ActionStore, CommonStore, BotStore];

/**
 * Maps objects from the store to the local container
 * We fetch different values from the various stores and then assign them
 * here so that they're available as props to the container component
 * @return {[type]} [description]
 */
export function getStateFromStores() {
  return {
    meta: CommonStore.getMetaTags(),
    currentLanguage: CommonStore.getCurrentLanguage(),
    isRephraseResponsesEnabled: BotStore.getFeatureFlag(
      FEATURE_FLAG_DATA.FLAGS.ENABLE_REPHRASE_RESPONSES
    ),
  };
}

export { createAlert } from '@src/actions/BotActions';
export { setCurrentScreen } from 'actions/StoryActions';
export { showRequestFailureAlert } from 'actions/ApiAction';
